<template>
  <v-container grid-list-md>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="400px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          color="success"
          dark
          v-bind="attrs"
          @click.stop="dialog = true"
        >
          <v-icon>fas fa-plus-circle</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          New Share Holder
          <v-spacer></v-spacer>
          <v-btn text icon @click.stop="close">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form" v-model="valid" class="mx-5">
          <v-text-field
            outlined
            v-model.trim="CustomerInfo.FullName"
            validate-on-blur
            :rules="[v => !!v || 'Full Name is required']"
            label="Full Name"
            color="success"
            prepend-inner-icon="fas fa-user-tie"
            required
          >
          </v-text-field>
          <v-text-field
            outlined
            v-model.number="CustomerInfo.Cusphone"
            validate-on-blur
            :rules="[v => !!v || 'Phone is required', minlength]"
            label="Phone"
            color="success"
            type="number"
            prepend-inner-icon="fas fa-phone-alt"
            required
          >
          </v-text-field>

          <v-text-field
            outlined
            v-model.trim="CustomerInfo.IDNomber"
            validate-on-blur
            :rules="[v => !!v || 'Passport or other ID is required']"
            label="ID Number"
            color="success"
            prepend-inner-icon="fas fa-address-card"
            required
          >
          </v-text-field>

          <v-select
            outlined
            v-model.trim="CustomerInfo.cashType"
            :items="GetCashTypes"
            :rules="[v => !!v || 'Cash Type is required']"
            label="Cash Type"
            prepend-inner-icon="fas fa-search-dollar"
            required
            no-data-text="Refresh the page"
          ></v-select>

          <!-- <v-col cols="12" md="3" sm="12">
              <v-text-field
                v-model.number="CustomerInfo.share"
                validate-on-blur
                :rules="[v => !!v || 'Share % is required']"
                label="Profit Share %"
                color="success"
                 prepend-inner-icon="fas fa-percent"
                required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <p class="mt-md-8 font-weight-black" v-if="CustomerInfo.share">
                {{ CustomerInfo.share / 100 }}%
              </p>
            </v-col> -->

          <BaseNumInput
            outlined
            label="Deposit Amount"
            v-model.number="CustomerInfo.amount"
          ></BaseNumInput>

          <!-- <v-text-field
            outlined
            v-model.number="CustomerInfo.amount"
            :rules="[v => !!v || 'Deposit Amount is required']"
            name="OpenBalance"
            label="Deposit Amount"
            type="number"
            prepend-inner-icon="fas fa-file-invoice-dollar"
          ></v-text-field> -->

          <!-- <v-col cols="12" md="6" sm="12">
              <p class="mt-md-4 font-weight-black" v-if="CustomerInfo.amount">
                {{ CustomerInfo.cashType | MoneySigns }}
                {{ CustomerInfo.amount.toLocaleString() }}
              </p>
            </v-col>
          </v-row> -->
          <!-- <p>{{ CustomerInfo }}</p> -->
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn
              color="success"
              class="mb-5"
              width="200px"
              :loading="clicked"
              @click="OnSaveCustomer"
            >
              Register
              <v-icon right>fas fa-plus</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
        <p v-if="ErrorMsg" class="red--text d-flex mt-2 justify-center">
          {{ ErrorMsg }}
        </p>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    loadFunction: { type: Function, required: true },
  },
  data() {
    return {
      dialog: false,
      clicked: false,
      valid: true,
      date: null,
      ErrorMsg: "",
      CustomerInfo: {
        FullName: null,
        Cusphone: null,
        IDNomber: null,
        cashType: null,
        amount: null,
      },
    };
  },

  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    close() {
      // console.log("colosed");
      this.dialog = false;
      this.$refs.form.reset();
      this.loadFunction();
    },
    isNumber(v) {
      if (v && isNaN(v)) return "Phone must be a number";
      else return false;
    },
    minlength(v) {
      // if (v && v.toString().length < 9)
      //   return "Phone length must be at least 9 number";
      // else return false;
      if (!v) return "Required phone";
      return (
        v.toString().length > 8 || "Phone length must be at least 9 number"
      );
    },
    OnSaveCustomer() {
      this.ErrorMsg = "";

      if (this.$refs.form.validate()) {
        this.clicked = true;
        this.CustomerInfo.date = this.Current().date;
        this.CustomerInfo.time = this.Current().time;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/owner",
            data: this.CustomerInfo,
          })
          .then(() => {
            this.loadFunction();
            this.$refs.form.reset();
            this.clicked = false;
            // console.log(result);
          })
          .catch(err => {
            this.clicked = false;
            // console.log(err.response);
            if (err.response.status === 400) this.ErrorMsg = err.response.data;
            if (err.response.status === 409)
              this.ErrorMsg = this.CustomerInfo.Cusphone + " is registred";
            else this.ErrorMsg = err.response.data;
          });
      }
    },
  },
  // created() {
  //   console.log(this.Current());
  //   console.log("Date");
  // }
};
</script>
